import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { fetchInitialConditions } from '../../../redux/reducers/PAEAA010';
import { postPABAA010recruit, postPAIAD010 } from '../../../services/Api';
import Loader from '../../../shared/components/Loader';
import Pagination from '../../../shared/components/Pagination';
import RecruitItem from '../../../shared/components/RecruitItem';
import SideNav from '../../../shared/components/SideNav';
import { decodeToken } from '../../../utils';
import PAEAA060 from '../../Recruit/PAEAA010/popupPAEAA060';
import PopupPAIAD010 from './PopupPAIAD010';
const PAIAD010 = () => {
    const [loading, setLoading] = useState(false);

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const [results, setResults] = useState([]);
    const [status, setStatus] = useState(true);
    const [infoResume, setInfoResume] = useState({});

    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [index, setIndex] = useState(0);
    const savedConditions = useSelector(({ PAEAA010 }) => PAEAA010.savedPAEAA010Conditions || []);

    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const [checkedValues, setCheckedValues] = useState({});
    const [checkedLikeRightValues, setCheckedLikeRightValues] = useState({});
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [applyMethod, setApplyMethod] = useState({});

    const [activePopup, setActivePopup] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const dispatch = useDispatch();

    const handlePopupClose = () => {
        setActivePopup(false);
        setSearchParams({ page: 1 });
    };
    const [itemSearch, setItemSearch] = useState([
        { label: '매칭조건 1', active: 1, disabled: 0 },
        { label: '매칭조건 2', active: 0, disabled: 0 },
        { label: '매칭조건 3', active: 0, disabled: 0 },
        { label: '매칭조건 4', active: 0, disabled: 0 },
        { label: '매칭조건 5', active: 0, disabled: 0 },
    ]);

    const hasValidParams = useCallback(() => {
        const options = Object.keys(checkedValues).length > 0 ? checkedValues : null;
        const optionLikeRight = Object.keys(checkedLikeRightValues).length > 0 ? checkedLikeRightValues : null;
        const method = Object.keys(applyMethod).length > 0 ? applyMethod : null;
        const startDateFormat = startDate ? moment(startDate).format('yyyy-MM-DD') : null;
        const endDateFormat = endDate ? moment(endDate).format('yyyy-MM-DD') : null;

        return options || optionLikeRight || method || startDateFormat || endDateFormat;
    }, [checkedValues, checkedLikeRightValues, applyMethod, startDate, endDate]);

    const fetchTab1Data = async () => {
        try {
            setLoading(true);
            const { data } = await postPAIAD010();
            setResults(data.data.list || []);
            setPages(data.data.info || {});
            setInfoResume(data.data.InfoResume || {});
            setStatus(false);
        } catch (error) {
            console.error(error);
            setResults([]);
            setPages({});
            setStatus(false);
        } finally {
            setLoading(false);
        }
    };

    const fetchTab2To5Data = async (conditionIndex) => {
        setLoading(true);
        const condition = savedConditions[conditionIndex - 1];

        if (!condition || !hasValidParams(condition)) {
            setResults([]);
            setPages({});
            setStatus(false);
            setLoading(false);
            return;
        }

        const startDateFormat = condition.startStoreDate ? moment(condition.startStoreDate).format('yyyy-MM-DD') : null;
        const endDateFormat = condition.endStoreDate ? moment(condition.endStoreDate).format('yyyy-MM-DD') : null;
        let options =
            Object.keys(condition.checkedStoreValues || {}).length === 0 ? null : condition.checkedStoreValues;
        const optionLikeRight =
            Object.keys(condition.checkedLikeRightStoreValues || {}).length === 0
                ? null
                : condition.checkedLikeRightStoreValues;
        const method = Object.keys(condition.applyMethodStore || {}).length === 0 ? null : condition.applyMethodStore;

        if (options && Array.isArray(options.RegionGu)) {
            const filteredRegionGu = options.RegionGu.filter((value) => {
                const numValue = parseInt(value);
                const isDivisibleBy100 = Number.isInteger(numValue) && numValue % 100 === 0;
                const endsWithZeros = value.endsWith('00');
                return !isDivisibleBy100 && !endsWithZeros;
            });

            if (filteredRegionGu.length === 0) {
                const { RegionGu, ...restOptions } = options;
                options = Object.keys(restOptions).length === 0 ? null : restOptions;
            } else {
                options = { ...options, RegionGu: filteredRegionGu };
            }
        }

        try {
            const { data } = await postPABAA010recruit({
                options,
                optionLikeRight,
                applyMethod: method,
                startDate: startDateFormat,
                endDate: endDateFormat,
                sortBy: 'modDate',
                page,
                size: 10,
            });

            setResults(data.data || []);
            setPages(data.info || {});
            setStatus(false);
        } catch (error) {
            console.error(error);
            setResults([]);
            setPages({});
            setStatus(false);
        } finally {
            setLoading(false);
        }
    };

    const getListData = async () => {
        if (index === 0) {
            await fetchTab1Data();
        } else {
            await fetchTab2To5Data(index);
        }
    };

    const handleChange = (e) => {
        const itemIndex = Number(e.currentTarget.dataset.index);
        setItemSearch((prevData) =>
            prevData.map((item, index) => ({
                ...item,
                active: itemIndex === index ? 1 : 0,
            })),
        );
        setIndex(itemIndex);
        setStatus(true);
    };

    const handleSelectSavedCondition = (index) => {
        if (index === 0) {
            setCheckedValues({});
            setCheckedLikeRightValues({});
            setStartDate('');
            setEndDate('');
            setApplyMethod({});
            setStatus(true);
            return;
        }

        const item = savedConditions[index - 1];
        if (!item) return;
        const { checkedStoreValues, checkedLikeRightStoreValues, startStoreDate, endStoreDate, applyMethodStore } =
            item;

        setCheckedValues(checkedStoreValues || {});
        setCheckedLikeRightValues(checkedLikeRightStoreValues || {});
        setStartDate(startStoreDate || '');
        setEndDate(endStoreDate || '');
        setApplyMethod(applyMethodStore || {});
        setStatus(true);
    };

    useEffect(() => {
        if (index !== null) {
            handleSelectSavedCondition(index);
        }
        // eslint-disable-next-line
    }, [index]);

    useEffect(() => {
        if (!activePopup) {
            handleSelectSavedCondition(index);
        }
        // eslint-disable-next-line
    }, [activePopup]);

    useEffect(() => {
        if (status || page) {
            getListData();
        }
        // eslint-disable-next-line
    }, [status, page]);

    useEffect(() => {
        dispatch(fetchInitialConditions());
    }, [dispatch]);

    useEffect(() => {
        setItemSearch((prevData) =>
            prevData.map((item, index) => ({
                ...item,
                disabled: index < savedConditions.length ? 0 : 1,
            })),
        );
    }, [savedConditions]);

    const openPopup = (data) => {
        setPopupData(data);
        setIsPopupOpen(true);
    };
    const closePopup = () => {
        setPopupData(null);
        setIsPopupOpen(false);
    };
    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div className="resume">
                            <div className="resume__inner">
                                <h3 className="resume__tit">추천 공고 <span>* 공개 되어 있는 이력서 정보를 바탕으로 최적의 채용 공고를 찾아드립니다.</span></h3>
                                <div className="rsm-stt">
                                    {/* <div className="rsm-mng">
                                        <div className="rsm-mng__btbx">
                                            <button
                                                type="button"
                                                id="mtchPopOpen"
                                                className="rsm-mng__btn"
                                                onClick={() => setActivePopup(true)}
                                            >
                                                추천 인재 조건 설정
                                            </button>
                                        </div>
                                    </div> */}
                                    <div className="mtch">
                                        {/* <div className="mtch__block">
                                            {itemSearch.map((item, index) => (
                                                <Link
                                                    className={`mtch__cnd ${item.active ? 'active' : ''}`}
                                                    onClick={handleChange}
                                                    key={index}
                                                    data-index={index}
                                                >
                                                    {`${item.label}`}
                                                </Link>
                                            ))}
                                        </div> */}
                                        <ul
                                            className={`mtch__state ${index === 0
                                                ? !infoResume || Object.keys(infoResume).length === 0
                                                : !savedConditions[index - 1]?.checkedStoreLabels?.length > 0
                                                    ? 'justify-content-center align-items-center'
                                                    : ''
                                                }`}
                                        >
                                            {index === 0 ? (
                                                infoResume && Object.keys(infoResume).length > 0 ? (
                                                    [
                                                        infoResume?.resumeClass,
                                                        infoResume?.resumeForm,
                                                        infoResume?.resumeLicense,
                                                        infoResume?.resumePosition,
                                                        infoResume?.resumePay,
                                                        infoResume?.resumeGrade,
                                                        // ...(infoResume.resumeClass
                                                        //     ? infoResume.resumeClass
                                                        //           .split(',')
                                                        //           .map((item) => item.trim())
                                                        //     : []),
                                                        // ...(infoResume.resumeForm
                                                        //     ? infoResume.resumeForm
                                                        //           .split(',')
                                                        //           .map((item) => item.trim())
                                                        //     : []),
                                                        // ...(infoResume.resumeLicense
                                                        //     ? infoResume.resumeLicense
                                                        //           .split(',')
                                                        //           .map((item) => item.trim())
                                                        //     : []),
                                                        // ...(infoResume.resumePosition
                                                        //     ? infoResume.resumePosition
                                                        //           .split(',')
                                                        //           .map((item) => item.trim())
                                                        //     : []),
                                                        // ...(infoResume.resumePay
                                                        //     ? infoResume.resumePay.split(',').map((item) => item.trim())
                                                        //     : []),
                                                        // ...(infoResume.resumeGrade
                                                        //     ? infoResume.resumeGrade
                                                        //           .split(',')
                                                        //           .map((item) => item.trim())
                                                        //     : []),
                                                        infoResume.resumeRegionSi1 && infoResume.resumeRegionGu1
                                                            ? `${infoResume.resumeRegionSi1} > ${infoResume.resumeRegionGu1}`
                                                            : null,
                                                        infoResume.resumeRegionSi2 && infoResume.resumeRegionGu2
                                                            ? `${infoResume.resumeRegionSi2} > ${infoResume.resumeRegionGu2}`
                                                            : null,
                                                        infoResume.resumeRegionSi3 && infoResume.resumeRegionGu3
                                                            ? `${infoResume.resumeRegionSi3} > ${infoResume.resumeRegionGu3}`
                                                            : null,
                                                    ]
                                                        .filter((item) => item !== null && item !== '')
                                                        .map((item, id) => <li key={`resume-${id}`}>{item}</li>)
                                                ) : (
                                                    <li>검색조건 없습니다</li>
                                                )
                                            ) : savedConditions[index - 1]?.checkedStoreLabels?.length > 0 ? (
                                                savedConditions[index - 1].checkedStoreLabels.map((item, id) => (
                                                    <li key={`condition-${id}`}>{item}</li>
                                                ))
                                            ) : (
                                                <li>검색조건 없습니다</li>
                                            )}
                                        </ul>
                                    </div>
                                    <div id="notification-tab" className="mtch__list ">
                                        <div className="wrap-table">
                                            <div className="header-table-container mt-2">
                                                <div
                                                    className="table table-header table-results gridTemplateColumns"
                                                    style={{
                                                        display: 'grid',
                                                        gridTemplateColumns: '240px 1fr 220px 130px',
                                                        borderBottom: '1px solid #ddd',
                                                        margin: '0',
                                                        paddingLeft: '10px',
                                                    }}
                                                >
                                                    <div className="column column-1">치과명</div>
                                                    <div className="column column-2">제목/담당업무/위치</div>
                                                    <div className="column column-3">경력/형태/자격증/수정</div>
                                                    <div className="column column-4">마감일</div>
                                                </div>
                                            </div>
                                            <ul
                                                className="table table-mtch__listlist wrap-table"
                                                style={{
                                                    borderTop: 'unset',
                                                    margin: '0',
                                                }}
                                            >
                                                {results && results.length > 0 ? (
                                                    results.map((item, index) => (
                                                        <RecruitItem
                                                            item={item}
                                                            key={index}
                                                            openPopup={openPopup}
                                                            refreshData={getListData}
                                                            showStar={true}
                                                            roleAction="P"
                                                        />
                                                    ))
                                                ) : (
                                                    <div className="no-data">
                                                        {loading ? <Loader /> : '등록된 채용정보가 없습니다.'}
                                                    </div>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                    {itemSearch[index].disabled === 0 && <Pagination pages={pages} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {activePopup && (
                <PopupPAIAD010 onClose={handlePopupClose} decode={decode} indexActive={index === 0 ? 1 : index} />
            )}
            {isPopupOpen && <PAEAA060 popupData={popupData} closePopup={closePopup} />}
        </>
    );
};

export default PAIAD010;
